// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * TimelogAttributes type.
 * @typedef {object} TimelogAttributes
 * @property {string} id - Attribute value.
 * @property {string | null} comment - Attribute value.
 * @property {Date | null} createdAt - Attribute value.
 * @property {Date | null} date - Attribute value.
 * @property {boolean} invoiced - Attribute value.
 * @property {number} pricePerHourCents - Attribute value.
 * @property {string} pricePerHourCurrency - Attribute value.
 * @property {string | null} taskId - Attribute value.
 * @property {number | null} timeSeconds - Attribute value.
 * @property {number | null} timeTransportSeconds - Attribute value.
 * @property {number | null} transportLength - Attribute value.
 * @property {Date | null} updatedAt - Attribute value.
 * @property {string | null} userId - Attribute value.
 */
/**
 * Attributes accepted by TimelogCreateAttributes.
 * @typedef {object} TimelogCreateAttributes
 * @property {TimelogAttributes["comment"] | null} [comment] - Permitted comment value.
 * @property {Date | string | null} [date] - Permitted date value.
 * @property {TimelogAttributes["invoiced"] | null} [invoiced] - Permitted invoiced value.
 * @property {TimelogAttributes["taskId"] | null} [taskId] - Permitted taskId value.
 * @property {TimelogAttributes["timeSeconds"] | null} [timeSeconds] - Permitted timeSeconds value.
 * @property {TimelogAttributes["timeTransportSeconds"] | null} [timeTransportSeconds] - Permitted timeTransportSeconds value.
 * @property {TimelogAttributes["transportLength"] | null} [transportLength] - Permitted transportLength value.
 * @property {TimelogAttributes["userId"] | null} [userId] - Permitted userId value.
 */
/**
 * Attributes accepted by TimelogUpdateAttributes.
 * @typedef {object} TimelogUpdateAttributes
 * @property {TimelogAttributes["comment"] | null} [comment] - Permitted comment value.
 * @property {Date | string | null} [date] - Permitted date value.
 * @property {TimelogAttributes["invoiced"] | null} [invoiced] - Permitted invoiced value.
 * @property {TimelogAttributes["taskId"] | null} [taskId] - Permitted taskId value.
 * @property {TimelogAttributes["timeSeconds"] | null} [timeSeconds] - Permitted timeSeconds value.
 * @property {TimelogAttributes["timeTransportSeconds"] | null} [timeTransportSeconds] - Permitted timeTransportSeconds value.
 * @property {TimelogAttributes["transportLength"] | null} [transportLength] - Permitted transportLength value.
 * @property {TimelogAttributes["userId"] | null} [userId] - Permitted userId value.
 */
/**
 * Frontend model for Timelog.
 * @augments {FrontendModelBase<TimelogAttributes, TimelogCreateAttributes, TimelogUpdateAttributes, TimelogAttributes["id"], string>}
 */
class Timelog extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "Timelog",
      attributes: [
        "id",
        "comment",
        "createdAt",
        "date",
        "invoiced",
        "pricePerHourCents",
        "pricePerHourCurrency",
        "taskId",
        "timeSeconds",
        "timeTransportSeconds",
        "transportLength",
        "updatedAt",
        "userId",
      ],
      collectionCommands: [
        "csvExport",
        "dashboardFilterOptions",
        "dashboardLogs",
        "markMatchingInvoiced",
        "markInvoiced",
        "dashboardSummary",
        "timelogsSummary",
        "workstatusSummary",
      ],
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      task: {type: "belongsTo"},
      user: {type: "belongsTo"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      task: "Task",
      user: "User",
    }
  }

  /** @returns {TimelogAttributes["id"]} - Attribute value. */
  id() { return /** @type {TimelogAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {TimelogAttributes["id"] | null} newValue - New attribute value.
   * @returns {TimelogAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {TimelogAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {TimelogAttributes["comment"]} - Attribute value. */
  comment() { return /** @type {TimelogAttributes["comment"]} */ (this.readAttribute("comment")) }

  /**
   * @param {TimelogAttributes["comment"] | null} newValue - New attribute value.
   * @returns {TimelogAttributes["comment"] | null} - Assigned value.
   */
  setComment(newValue) { return /** @type {TimelogAttributes["comment"] | null} */ (this.setAttribute("comment", newValue)) }

  /** @returns {TimelogAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {TimelogAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {TimelogAttributes["date"]} - Attribute value. */
  date() { return /** @type {TimelogAttributes["date"]} */ (this.readAttribute("date")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setDate(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("date", newValue)) }

  /** @returns {TimelogAttributes["invoiced"]} - Attribute value. */
  invoiced() { return /** @type {TimelogAttributes["invoiced"]} */ (this.readAttribute("invoiced")) }

  /**
   * @param {TimelogAttributes["invoiced"] | null} newValue - New attribute value.
   * @returns {TimelogAttributes["invoiced"] | null} - Assigned value.
   */
  setInvoiced(newValue) { return /** @type {TimelogAttributes["invoiced"] | null} */ (this.setAttribute("invoiced", newValue)) }

  /** @returns {TimelogAttributes["pricePerHourCents"]} - Attribute value. */
  pricePerHourCents() { return /** @type {TimelogAttributes["pricePerHourCents"]} */ (this.readAttribute("pricePerHourCents")) }

  /**
   * @param {TimelogAttributes["pricePerHourCents"] | null} newValue - New attribute value.
   * @returns {TimelogAttributes["pricePerHourCents"] | null} - Assigned value.
   */
  setPricePerHourCents(newValue) { return /** @type {TimelogAttributes["pricePerHourCents"] | null} */ (this.setAttribute("pricePerHourCents", newValue)) }

  /** @returns {TimelogAttributes["pricePerHourCurrency"]} - Attribute value. */
  pricePerHourCurrency() { return /** @type {TimelogAttributes["pricePerHourCurrency"]} */ (this.readAttribute("pricePerHourCurrency")) }

  /**
   * @param {TimelogAttributes["pricePerHourCurrency"] | null} newValue - New attribute value.
   * @returns {TimelogAttributes["pricePerHourCurrency"] | null} - Assigned value.
   */
  setPricePerHourCurrency(newValue) { return /** @type {TimelogAttributes["pricePerHourCurrency"] | null} */ (this.setAttribute("pricePerHourCurrency", newValue)) }

  /** @returns {TimelogAttributes["taskId"]} - Attribute value. */
  taskId() { return /** @type {TimelogAttributes["taskId"]} */ (this.readAttribute("taskId")) }

  /**
   * @param {TimelogAttributes["taskId"] | null} newValue - New attribute value.
   * @returns {TimelogAttributes["taskId"] | null} - Assigned value.
   */
  setTaskId(newValue) { return /** @type {TimelogAttributes["taskId"] | null} */ (this.setAttribute("taskId", newValue)) }

  /** @returns {TimelogAttributes["timeSeconds"]} - Attribute value. */
  timeSeconds() { return /** @type {TimelogAttributes["timeSeconds"]} */ (this.readAttribute("timeSeconds")) }

  /**
   * @param {TimelogAttributes["timeSeconds"] | null} newValue - New attribute value.
   * @returns {TimelogAttributes["timeSeconds"] | null} - Assigned value.
   */
  setTimeSeconds(newValue) { return /** @type {TimelogAttributes["timeSeconds"] | null} */ (this.setAttribute("timeSeconds", newValue)) }

  /** @returns {TimelogAttributes["timeTransportSeconds"]} - Attribute value. */
  timeTransportSeconds() { return /** @type {TimelogAttributes["timeTransportSeconds"]} */ (this.readAttribute("timeTransportSeconds")) }

  /**
   * @param {TimelogAttributes["timeTransportSeconds"] | null} newValue - New attribute value.
   * @returns {TimelogAttributes["timeTransportSeconds"] | null} - Assigned value.
   */
  setTimeTransportSeconds(newValue) { return /** @type {TimelogAttributes["timeTransportSeconds"] | null} */ (this.setAttribute("timeTransportSeconds", newValue)) }

  /** @returns {TimelogAttributes["transportLength"]} - Attribute value. */
  transportLength() { return /** @type {TimelogAttributes["transportLength"]} */ (this.readAttribute("transportLength")) }

  /**
   * @param {TimelogAttributes["transportLength"] | null} newValue - New attribute value.
   * @returns {TimelogAttributes["transportLength"] | null} - Assigned value.
   */
  setTransportLength(newValue) { return /** @type {TimelogAttributes["transportLength"] | null} */ (this.setAttribute("transportLength", newValue)) }

  /** @returns {TimelogAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {TimelogAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("updatedAt", newValue)) }

  /** @returns {TimelogAttributes["userId"]} - Attribute value. */
  userId() { return /** @type {TimelogAttributes["userId"]} */ (this.readAttribute("userId")) }

  /**
   * @param {TimelogAttributes["userId"] | null} newValue - New attribute value.
   * @returns {TimelogAttributes["userId"] | null} - Assigned value.
   */
  setUserId(newValue) { return /** @type {TimelogAttributes["userId"] | null} */ (this.setAttribute("userId", newValue)) }

  /**
   * Runs csvExport.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{csv: string, count: number, filename: string}>} - Command response.
   */
  static async csvExport(...commandArguments) {
    return /** @type {{csv: string, count: number, filename: string}} */ (await this.executeCustomCommand({
      commandName: "csv-export",
      commandType: "csv-export",
      payload: Timelog.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs dashboardFilterOptions.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<import("../../../shared/timelog-dashboard-types.js").TimelogDashboardFilterOptions>} - Command response.
   */
  static async dashboardFilterOptions(...commandArguments) {
    return /** @type {import("../../../shared/timelog-dashboard-types.js").TimelogDashboardFilterOptions} */ (await this.executeCustomCommand({
      commandName: "dashboard-filter-options",
      commandType: "dashboard-filter-options",
      payload: Timelog.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs dashboardLogs.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<import("../../../shared/projected-timelog-reporting-types.js").ProjectedTimelogDashboardRow[]>} - Command response.
   */
  static async dashboardLogs(...commandArguments) {
    return /** @type {import("../../../shared/projected-timelog-reporting-types.js").ProjectedTimelogDashboardRow[]} */ (await this.executeCustomCommand({
      commandName: "dashboard-logs",
      commandType: "dashboard-logs",
      payload: Timelog.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs markMatchingInvoiced.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{markedCount: number}>} - Command response.
   */
  static async markMatchingInvoiced(...commandArguments) {
    return /** @type {{markedCount: number}} */ (await this.executeCustomCommand({
      commandName: "mark-matching-invoiced",
      commandType: "mark-matching-invoiced",
      payload: Timelog.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs markInvoiced.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{markedCount: number}>} - Command response.
   */
  static async markInvoiced(...commandArguments) {
    return /** @type {{markedCount: number}} */ (await this.executeCustomCommand({
      commandName: "mark-invoiced",
      commandType: "mark-invoiced",
      payload: Timelog.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs dashboardSummary.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<import("../../../shared/timelog-dashboard-types.js").TimelogDashboardSummary>} - Command response.
   */
  static async dashboardSummary(...commandArguments) {
    return /** @type {import("../../../shared/timelog-dashboard-types.js").TimelogDashboardSummary} */ (await this.executeCustomCommand({
      commandName: "dashboard-summary",
      commandType: "dashboard-summary",
      payload: Timelog.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs timelogsSummary.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{count: number, invoicedCount: number, notInvoicedCount: number, totalSeconds: number, totalTransportSeconds: number}>} - Command response.
   */
  static async timelogsSummary(...commandArguments) {
    return /** @type {{count: number, invoicedCount: number, notInvoicedCount: number, totalSeconds: number, totalTransportSeconds: number}} */ (await this.executeCustomCommand({
      commandName: "timelogs-summary",
      commandType: "timelogs-summary",
      payload: Timelog.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs workstatusSummary.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<import("../../../shared/timelog-dashboard-types.js").WorkstatusSummary>} - Command response.
   */
  static async workstatusSummary(...commandArguments) {
    return /** @type {import("../../../shared/timelog-dashboard-types.js").WorkstatusSummary} */ (await this.executeCustomCommand({
      commandName: "workstatus-summary",
      commandType: "workstatus-summary",
      payload: Timelog.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Returns task relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Timelog, import("./task.js").Task, import("./task.js").TaskCreateAttributes>} - Relationship helper.
   */
  taskRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Timelog, import("./task.js").Task, import("./task.js").TaskCreateAttributes>} */ (this.getRelationshipByName("task")) }

  /**
   * Returns task.
   * @returns {import("./task.js").Task | null} - Loaded related model.
   */
  task() { return this.taskRelationship().loaded() }

  /**
   * Builds task.
   * @param {import("./task.js").TaskCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./task.js").Task} - Built related model.
   */
  buildTask(attributes = {}) { return this.taskRelationship().build(attributes) }

  /**
   * Loads task.
   * @returns {Promise<import("./task.js").Task | null>} - Loaded related model.
   */
  async loadTask() { return await this.taskRelationship().load() }

  /**
   * Returns or loads task.
   * @returns {Promise<import("./task.js").Task | null>} - Loaded related model.
   */
  async taskOrLoad() { return await this.taskRelationship().orLoad() }

  /**
   * Sets task.
   * @param {import("./task.js").Task | null} model - Related model.
   * @returns {void}
   */
  setTask(model) { this.taskRelationship().setLoaded(model) }

  /**
   * Returns user relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Timelog, import("./user.js").User, import("./user.js").UserCreateAttributes>} - Relationship helper.
   */
  userRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Timelog, import("./user.js").User, import("./user.js").UserCreateAttributes>} */ (this.getRelationshipByName("user")) }

  /**
   * Returns user.
   * @returns {import("./user.js").User | null} - Loaded related model.
   */
  user() { return this.userRelationship().loaded() }

  /**
   * Builds user.
   * @param {import("./user.js").UserCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./user.js").User} - Built related model.
   */
  buildUser(attributes = {}) { return this.userRelationship().build(attributes) }

  /**
   * Loads user.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async loadUser() { return await this.userRelationship().load() }

  /**
   * Returns or loads user.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async userOrLoad() { return await this.userRelationship().orLoad() }

  /**
   * Sets user.
   * @param {import("./user.js").User | null} model - Related model.
   * @returns {void}
   */
  setUser(model) { this.userRelationship().setLoaded(model) }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(Timelog)

export {Timelog}

export default Timelog
